module.exports = __webpack_public_path__ + "img/87100d5206e3a4aab0ce048d6207a935.svg";